import QuizzesService from "@/api/services/quizzes";
import { toCamelCase } from "@estaly/ui";

export default {
  namespaced: true,

  state: {
    currentQuiz: null,
    lastAttempt: null,
  },

  mutations: {
    SET_CURRENT_QUIZ(state, quiz) {
      state.currentQuiz = quiz;
    },
    SET_LAST_ATTEMPT(state, attempt) {
      state.lastAttempt = attempt;
    },
  },

  actions: {
    async fetchQuiz({ commit }, quizId) {
      const response = await QuizzesService.fetch(quizId);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("SET_CURRENT_QUIZ", data.quiz);

      return response;
    },

    async submitAttempt({ commit }, { quizId, sellerId, storeId, answers }) {
      const response = await QuizzesService.submitAttempt(quizId, { sellerId, storeId, answers });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("SET_LAST_ATTEMPT", data.quizAttempt);

      return response;
    },
  },
};
